import React, { useEffect, useState } from 'react'
import InputContainer from '../../layout/inputContainer';
import { Checkbox } from '@mui/material';
// import { nameSuffix, relationSuffix } from "../../data";

export default function Address({
	applicationFlow,
	defaultValues,
	namePrefix,
	control,
	watch,
	setValue,
}) {
	const permanentAddressKey = 'landInfo.owners[0].permanentAddress';
	const isPermanentAddress = namePrefix === permanentAddressKey;
	const [
		watchCorrespondenceAddress,
		watchCorrespondenceDistrict,
		watchCorrespondenceTehsil,
		watchPermanentDistrict,
		watchPermanentTehsil,
	] = watch([
		'landInfo.owners[0].correspondenceAddress',
		'landInfo.owners[0].correspondenceAddress.district',
		'landInfo.owners[0].correspondenceAddress.tehsil',
		'landInfo.owners[0].permanentAddress.district',
		'landInfo.owners[0].permanentAddress.tehsil',
	]);

	const handleSameAsCorrespondence = (e) => {
		if (e.target.checked) {
			setValue(permanentAddressKey, watchCorrespondenceAddress);
		} else {
			setValue(permanentAddressKey, {
				applicantName: '',
				applicantGuardianName: '',
				state: 'Uttar Pradesh',
				district: '',
				tehsil: '',
				town: '',
				address: '',
				pinno: '',
				type: isPermanentAddress ? "PERMANENT" : "CORRESPONDENCE",
			});
		}
	};
	const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
	const districtList = !isDistrictDataLoading && applicationFlow ? districtData?.filter((district) => district.code?.includes(applicationFlow.toLowerCase())) : [];
	const [correspondenceTehsilList, setCorrespondenceTehsilList] = useState([]);
	const [permanentTehsilList, setPermanentTehsilList] = useState([]);

	useEffect(() => {
		if (watchCorrespondenceDistrict) {
			const tehsilList = districtList.find(item => item.name === watchCorrespondenceDistrict)?.boundary;
			setCorrespondenceTehsilList(tehsilList);
		}
	}, [watchCorrespondenceDistrict]);

	useEffect(() => {
		if (watchPermanentDistrict) {
			const tehsilList = districtList.find(item => item.name === watchPermanentDistrict)?.boundary;
			setPermanentTehsilList(tehsilList);
		}
	}, [watchPermanentDistrict]);

	return (
		<div className="columnWrapper">
			{isPermanentAddress ? (
				<div className="checkboxWrapper">
					<h3 className="addressType">Permanent Address</h3>
					<label style={{
						alignItems: 'center',
						width: '18.25vw',
						marginBottom: 0,
						display: 'flex',
						gap: '0.5rem',
						translate: '-8px 0',
					}}>
						<Checkbox onChange={handleSameAsCorrespondence} />
						Same as Corr. Address
					</label>
				</div>
			) : (
				<h3 className="addressType">Correspondence Address</h3>
			)}
			<InputContainer
				control={control}
				label="Name"
				// placeholder={defaultValues.applicantName || "Enter Name"}
				defaultValue={defaultValues?.applicantName}
				name={`${namePrefix}.applicantName`}
				type="textInput"
				mandatory
				maxLength={30}
			// selectSuffix={{
			//   name: `${namePrefix}.initialForApplicantName`,
			//   data: nameSuffix,
			//   defaultValue: 'Mr.',
			//   control,
			// }}
			validation={{
				required: {
					value: true,
					message: "This field is required"
				},
				pattern: {
					value: Digit.Utils.getPattern('Name'),
					message: "Please enter only letters and spaces",
				},
			}}
			/>
			<InputContainer
				control={control}
				label="Guardian Name"
				maxLength={30}
				// placeholder={defaultValues.applicantGuardianName ? '' : "Enter Guardian Name"}
				defaultValue={defaultValues?.applicantGuardianName}
				name={`${namePrefix}.applicantGuardianName`}
				type="textInput"
				mandatory
				validation={{
					required: {
						value: true,
						message: "This field is required"
					},
					pattern: {
						value: Digit.Utils.getPattern('Name'),
						message: "Please enter only letters and spaces",
					},
				}}
			/>
			<InputContainer
				control={control}
				label="State"
				// placeholder="State"
				defaultValue={defaultValues?.state || 'Uttar Pradesh'}
				name={`${namePrefix}.state`}
				type="textInput"
				disabled
			/>
			<InputContainer
				control={control}
				data={districtList}
				label="District"
				placeholder={watchPermanentDistrict && 'District' || defaultValues?.district || 'District'}
				defaultValue={defaultValues?.district}
				name={`${namePrefix}.district`}
				type="selectInput"
				mandatory
				maxLength={25}
				validation={{
					required: {
					  value: true,
					  message: "This field is required" 
					}
				  }}
			/>
			<InputContainer
				control={control}
				data={isPermanentAddress ? permanentTehsilList : correspondenceTehsilList}
				label="Tehsil"
				placeholder={(isPermanentAddress ? watchPermanentTehsil : watchCorrespondenceTehsil) && 'Tehsil' || defaultValues?.tehsil || 'Tehsil'}
				defaultValue={defaultValues?.tehsil}
				name={`${namePrefix}.tehsil`}
				type="textInput"
				mandatory
				maxLength={25}
				validation={{
					required: {
					  value: true,
					  message: "This field is required" 
					}
				  }}
			// disabled={permanentTehsilList.length <= 0}
			/>
			<InputContainer
				control={control}
				label="Town/Village/Ward"
				placeholder="Enter Town/Village/Ward"
				defaultValue={defaultValues?.town}
				name={`${namePrefix}.town`}
				type="textInput"
				mandatory
				maxLength={26}
				validation={{
					required: {
					  value: true,
					  message: "This field is required" 
					}
				  }}
			/>
			<InputContainer
				control={control}
				label="Address"
				placeholder="Enter Address"
				defaultValue={defaultValues?.address}
				name={`${namePrefix}.address`}
				type="textInput"
				mandatory
				multiLine
				maxLength={150}
				validation={{
					required: {
					  value: true,
					  message: "This field is required" 
					},
					pattern: {
					  value: Digit.Utils.getPattern('Address'),
					  message: "Please enter valid Address",
					},
				  }}
			/>
			<InputContainer
				control={control}
				label="Pincode"
				placeholder="Enter Pincode"
				defaultValue={defaultValues?.pinno}
				name={`${namePrefix}.pinno`}
				type="textInput"
				mandatory
				validation={{
					required: {
					  value: true,
					  message: "This field is required" 
					},
					pattern: {
					  value: Digit.Utils.getPattern('Pincode'),
					  message: "Please enter valid Pincode",
					},
				  }}
				maxLength={6}
			/>
		</div>
	)
}
